export default __webpack_public_path__ + "static/media/Snd_TryD.bc5d52ad.mp3";